<template>
  <b-card
    class="mb-1"
    img-top
  >
    <b-skeleton-img
      card-img="top"
    />

    <b-skeleton
      animation="wave"
      width="85%"
      class="mt-1"
    />
    <b-skeleton
      animation="wave"
      width="55%"
    />
    <b-skeleton
      animation="wave"
      width="70%"
    />
  </b-card>
</template>

<script>

export default { }

</script>
